// @flow

import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setUIState } from 'redux/modules/ui'
import { actions as FavoriteActions } from 'redux/modules/favorite'
import { actions as LocalRoomsActions } from 'redux/modules/local/rooms'
import RoomCardSlider from 'components/organisms/room/RoomCardSlider'
import type { Room as RoomType } from 'types/room'

import graphql from './graphql'
import RoomSliderUseCase, { type RoomSliderUseCaseType } from '../usecase'

type PropTypes = {
  data: {
    viewer: {
      browseRoomHistories: {
        results: Array<RoomType>,
      },
    },
  },
  localRooms: {
    roomMap: Object,
  },
  usecase: RoomSliderUseCaseType,
}

class BrowseRoomHistoriesSlider extends Component<PropTypes> {
  componentDidMount() {
    const { usecase, data } = this.props
    if (data.viewer && data.viewer.browseRoomHistories) {
      usecase.initialize(data.viewer.browseRoomHistories.results)
    }
  }

  render() {
    const { data, localRooms, usecase, ui } = this.props
    const { addedFavoriteListName, showingFavoriteListTooltipList } = ui
    if (!data) {
      return null
    }

    const { viewer } = data
    if (!viewer || viewer.browseRoomHistories.results.length === 0) {
      return null
    }

    return (
      <RoomCardSlider
        title={i18n.t('page.room.historyRoomsTitle')}
        roomList={data.viewer.browseRoomHistories.results.map(browseRoom => ({
          ...browseRoom,
          isFavorite: (localRooms.roomMap[browseRoom.id] || {}).isFavorite,
        }))}
        addedFavoriteListName={addedFavoriteListName}
        showingFavoriteListTooltipList={showingFavoriteListTooltipList}
        onClickFavorite={(e: Event, clickedRoom: RoomType) =>
          usecase.addFavorite(e, clickedRoom, showingFavoriteListTooltipList)
        }
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    room: state.room,
    localRooms: state.localRooms,
    config: state.config,
  }
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, ...LocalRoomsActions, ...FavoriteActions }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(RoomSliderUseCase(BrowseRoomHistoriesSlider))),
)



// WEBPACK FOOTER //
// ./src/containers/organisms/room/RoomCardSlider/BrowseRoomHistories/index.jsx